import { ISynchronizationRequest } from '@domain/interfaces/hooks/IStoreSynchronization';
import {
  ESynchronizationType,
  ESynchronizationRequestType,
} from '@domain/enums/hooks/ESynchronization';
import { IAliases } from '@domain/interfaces/integrations/marketing/taboola/IAliases';
import { IUpdateGoogleCampaign } from '@domain/interfaces/dashboard/AdSense/Google/IGoogleCampaign';

import { LONG_API_DOMAIN } from '@constants/api';

import { getEnvironment } from '@helpers/utils/environment';

import taboolaCampaignService from '@services/pages/dashboard/adSense/taboola/taboolaCampaign';

export const getUpdateTaboolaCampaignPromise = ({
  adSenseCampaignAliasId,
  data,
  productAliasId,
  storeAliasId,
}: IUpdateGoogleCampaign): Promise<any> => {
  return taboolaCampaignService.updateTaboolaCampaign({
    adSenseCampaignAliasId,
    data,
    productAliasId,
    storeAliasId,
  });
};

export const getTaboolaSynchronizationRequestConfig = (
  type: ESynchronizationType,
  storeAliasId: string | undefined,
  aliases: IAliases | undefined,
  data: any | undefined,
): ISynchronizationRequest => {
  if (type === ESynchronizationType.AD_SENSE_ACCOUNTS) {
    return {
      type: ESynchronizationRequestType.POST,
      domain: LONG_API_DOMAIN,
      api: `/${getEnvironment()}/api/v1/users/stores/${storeAliasId}/ad-sense-credentials/${
        aliases?.adSenseCredentialAliasId
      }/taboola/ad-sense-accounts/sync`,
    };
  }

  if (type === ESynchronizationType.UPDATE_AD_SENSE_ACCOUNTS) {
    return {
      type: ESynchronizationRequestType.PUT,
      domain: LONG_API_DOMAIN,
      api: `/${getEnvironment()}/api/v1/users/stores/${storeAliasId}/ad-sense-credentials/${
        aliases?.adSenseCredentialAliasId
      }/taboola/ad-sense-accounts/${aliases?.adSenseAccountAliasId}`,
      requestBody: { ...data },
    };
  }

  if (type === ESynchronizationType.AD_SENSE_CAMPAIGNS) {
    return {
      type: ESynchronizationRequestType.POST,
      domain: LONG_API_DOMAIN,
      api: `/${getEnvironment()}/api/v1/users/stores/${storeAliasId}/taboola/ad-sense-campaigns/sync`,
    };
  }

  return {
    type: ESynchronizationRequestType.PUT,
    domain: LONG_API_DOMAIN,
    api: `/${getEnvironment()}/api/v1/users/stores/${storeAliasId}/products/${
      aliases?.productAliasId
    }/taboola/ad-sense-campaigns/${aliases?.adSenseCampaignAliasId}`,
    requestBody: { ...data },
  };
};
